import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoisePicturesStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.store';
import { FpLoggerNoisePicturesActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/services/fp-logger-noise-pictures/fp-logger-noise-pictures.actions';
import { FpLoggerNoisePicturesComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/components/fp-logger-noise-pictures/fp-logger-noise-pictures.component';
import { FpLoggerNoisePicturesMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-pictures/components/fp-logger-noise-pictures-minimized/fp-logger-noise-pictures-minimized.component';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoisePicturesConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoisePicturesStore);
  public currentTab = FpLoggerNoiseTabs.Pictures;

  public component: Type<unknown> = FpLoggerNoisePicturesComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoisePicturesMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isActive(tab: FpLoggerNoiseTabs): boolean {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoisePicturesActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger): void {
    this.tabStore.dispatch({
      type: FpLoggerNoisePicturesActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
